

import __layout_0 from '/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/blank.vue'),
'default': __layout_0,
'jdesktop': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/jdesktop.vue'),
'member': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/member.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/EventChatStatusSwitcher': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/EventChatStatusSwitcher.vue'),
'components/Footer': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/runner/work/pasde_webinar/pasde_webinar/resources/js/vue/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
